export default __webpack_public_path__ + "808f25a5744876fba26caa98426098e8.png";